import React, { useState } from 'react';
import ReportCategorySelector, { ReportCategory } from './ReportCategorySelector';
import DonationReportsPanel from './DonationReportsPanel';
import IncomeReportsPanel from './IncomeReportsPanel';
import ExpenseReportsPanel from './ExpenseReportsPanel';

const AdvancedReports: React.FC = () => {
  const [reportCategory, setReportCategory] = useState<ReportCategory | null>(null);

  if (!reportCategory) {
    return <ReportCategorySelector onSelect={setReportCategory} />;
  }

  const back = () => setReportCategory(null);

  if (reportCategory === 'donation') {
    return <DonationReportsPanel onBack={back} />;
  }
  if (reportCategory === 'income') {
    return <IncomeReportsPanel onBack={back} />;
  }
  return <ExpenseReportsPanel onBack={back} />;
};

export default AdvancedReports;
